import React from 'react';

export default () => (
  <div className="flex-center">
    <div className="lds-roller">
      <div/><div/><div/><div/><div/><div/><div/><div/></div>
  </div>
);
